// SPDX-FileCopyrightText: 2026 Povl Filip Sonne-Frederiksen
//
// SPDX-License-Identifier: GPL-3.0-or-later

import type { ReactNode } from 'react';

import { SegmentedControl } from '../SegmentedControl';
import styles from './SubTabs.module.css';

export interface SubTab {
  id: string;
  label: string;
  /** Case-relative href (`/rediger/scan`), query included. */
  href: string;
}

export interface SubTabsProps {
  /** The mode they belong to, for the nav's name ("Rediger"). */
  mode: string;
  tabs: readonly SubTab[];
  /** The current sub-tab, or null while the mode picks its default one. */
  current: string | null;
  /** Right of the tabs, in the same bar (a sub-tab's own controls). */
  children?: ReactNode;
}

/**
 * A mode's sub-tabs (Rediger › Scan & pose | Geometri | Import,
 * frontend-u0o.1): a floating bar just under the top bar, at its left edge,
 * like the v8 prototype's second row. Links, so a sub-tab opens in a new
 * browser tab like a mode does. The shell moves the tiles and the Ground's
 * tools down by `--shell-subbar` while it shows.
 */
export function SubTabs({ mode, tabs, current, children }: SubTabsProps) {
  return (
    <div className={styles.bar}>
      <SegmentedControl
        role="nav"
        aria-label={mode}
        size="md"
        items={tabs.map((t) => ({ value: t.id, label: t.label, href: t.href }))}
        value={current}
      />
      {children}
    </div>
  );
}
